import { modelPool } from "@modules/model";
import { MediaScreenFacet, MediaScreenFacetType } from "flavr-common";
export const findMediaScreenModels = () => {
    return modelPool
        .findModelsWithFacets(MediaScreenFacet)
        .map(model => { return { model, facet: model.getFacet(MediaScreenFacet) }; })
        .filter(m => { var _a; return ((_a = m.facet) === null || _a === void 0 ? void 0 : _a.params.type) === MediaScreenFacetType.screenShare; })
        .map(m => m.model);
};
export const findMediaScreenModelsInRoom = (roomUID) => {
    var _a;
    const room = modelPool.getRoom(roomUID);
    if (room === undefined) {
        console.warn(`[mediascreen] Room with UID ${roomUID} doesn't exist`);
        return [];
    }
    return (_a = room === null || room === void 0 ? void 0 : room.getChildrenInRoom().filter(model => model.hasFacet(MediaScreenFacet)).map(model => { return { model, facet: model.getFacet(MediaScreenFacet) }; }).filter(m => { var _a; return ((_a = m.facet) === null || _a === void 0 ? void 0 : _a.params.type) === MediaScreenFacetType.screenShare; }).map(m => m.model)) !== null && _a !== void 0 ? _a : [];
};
